<!-- HEADER -->
<app-header color="transparent"></app-header>

<!-- CONTENT -->
<ion-content class="padded">
  <section>
    <!-- BREADCRUMBS -->
    <ul class="breadcrumb">
      <li>
        <a [routerLink]="'/'">Home</a><ion-icon name="chevron-forward-outline"></ion-icon>
      </li>
      <li>
        <span>What's On</span>
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </li>
      <li [class.active]="!selectedCategory?.title">
        <a (click)="resetCategories()">Offers</a>
      </li>
      <li *ngIf="selectedCategory?.title">
        <ion-icon name="chevron-forward-outline"></ion-icon>
        {{selectedCategory.title}}
      </li>
    </ul>

    <!-- HEADING & CATEGORY SELECT -->
    <ion-row class="listing-header ion-align-items-center">
      <ion-col class="ion-no-padding">
        <ion-text color="dark">
          <h1 class="h2 page-title" *ngIf="selectedCategory?.title; else pageTitle">
            {{selectedCategory.title}}
          </h1>
          <ng-template #pageTitle>
            <h1 class="h2 page-title">{{data?.title | uppercase}}</h1>
          </ng-template>
        </ion-text>
      </ion-col>
      <ion-col size="auto" size-md="3" class="ion-no-padding ion-justify-content-end ion-text-right">
        <ion-text class="select-trigger" *ngIf="data" (click)="presentPopover($event)">
          <ion-text class="select-text">Filter Offers</ion-text>
        </ion-text>
      </ion-col>
    </ion-row>

    <!-- INTRO -->
    <app-paragraph [node]="{text: data?.excerpt}" [readMore]="true" class="page-intro"></app-paragraph>

    <section *ngIf="!data?.items">
      <!-- LISTING GRID -->
      <ion-grid class="card-grid">
        <ion-row>
          <ion-col size="12" size-md="4" *ngFor="let card of [0,1,2]">
            <ion-card>
              <ion-skeleton-text animated style="padding-top: 56.25%; margin-bottom: 0"></ion-skeleton-text>
              <ion-card-header>
                <ion-card-subtitle>
                  <ion-skeleton-text animated
                    style="display: inline-block; width: 60px; height: 17px"></ion-skeleton-text>
                  &nbsp; &nbsp;
                  <ion-skeleton-text animated
                    style="display: inline-block; width: 100px; height: 17px"></ion-skeleton-text>
                </ion-card-subtitle>
                <ion-card-title>
                  <ion-skeleton-text animated style="margin-top: 10px; height: 24px"></ion-skeleton-text>
                </ion-card-title>
              </ion-card-header>
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-grid>
    </section>

    <section *ngIf="data?.items">
      <!-- LISTING GRID -->
      <ion-grid class="card-grid">
        <!-- RESULTS -->
        <ion-row>
          <ng-container *ngFor="let item of data?.items; let i = index">
            <ion-col size="12" size-md="4">
              <app-card [data]="item" class="card-boxed"
                [img]="{ url: item.featuredImage, alt: item.title, aspectRatio: '16:9' }"
                [hideCategory]="true"></app-card>
            </ion-col>
          </ng-container>
        </ion-row>

        <!-- NO RESULTS -->
        <ion-row *ngIf="data?.items.length === 0">
          <ion-col>
            <h3 *ngIf="!selectedCategory; else hasBlogs">
              There are currently no offers.
            </h3>
            <ng-template #hasBlogs>
              <h3>
                There are currently no offers in the
                <i>{{selectedCategory.title}}</i> category.
              </h3>
              <app-button
                type="secondary"
                (click)="resetCategories()"
              >
                View all Offers
              </app-button>
            </ng-template>
          </ion-col>
        </ion-row>

        <!-- LOAD MORE -->
        <ion-row class="listing-pagination">
          <ion-col class="ion-flex ion-justify-content-center">
            <app-button *ngIf="hasMoreItems" type="secondary" (click)="loadMore()" [disabled]="xhrInProgress"
              [icon]="{ name: 'arrow-right', position: 'right' }">
              <ng-container *ngIf="xhrInProgress; else loadMsg">
                Loading
              </ng-container>
              <ng-template #loadMsg>
                Load more
              </ng-template>
            </app-button>
          </ion-col>
        </ion-row>
      </ion-grid>
    </section>
  </section>

  <!-- CONTACT / CTA STRIP -->
  <app-contact-strip></app-contact-strip>

  <!-- FOOTER -->
  <app-footer></app-footer>
</ion-content>